import Loading, { LoadingBall } from '@ingka/loading';

export interface LoaderProps {
  text?: string;
}

const Loader: React.FC<LoaderProps> = ({ text }) => {
  return (
    <Loading text={text || ''}>
      <LoadingBall />
    </Loading>
  );
};

export default Loader;
